import {
    JobCardList,
    H6,
    useFilter,
    useJobStory,
    GhostButtonNeutral,
} from 'rwl-ui';
import { useGlobal } from '../../hooks';
import { useFetchJobs } from '../../fetchers/JobFetcher/useFetchJobs';
import { Else, If, Then, When } from 'react-if';

export const MAX_MATCHING_JOBS = 20;

type FilterMatchingJobsProps = {
    onShowMoreClicked?: () => void;
};

export const FilterMatchingJobs = ({
    onShowMoreClicked,
}: FilterMatchingJobsProps): JSX.Element | null => {
    const { accountId, config } = useGlobal();
    const { appliedFilters } = useFilter();
    const { setJobStoryId } = useJobStory();
    const { data, isLoading } = useFetchJobs({
        accountId,
        filters: appliedFilters,
        enabled: true,
        bounds: undefined,
        pageSize: MAX_MATCHING_JOBS,
        showcaseOnly: config?.extraData?.showcaseOnly,
    });
    if (isLoading || !data?.workSites?.length) {
        return null;
    }

    function findJobAndSetStory(jobId: string) {
        setJobStoryId(jobId);
    }

    return (
        <div style={{ width: '100%', paddingTop: 30 }}>
            <H6>{data?.count} nearby jobs that match your filter</H6>
            <JobCardList
                jobList={data?.workSites}
                onJobCardClicked={findJobAndSetStory}
            />
            <When condition={!!onShowMoreClicked}>
                <GhostButtonNeutral
                    style={{ marginTop: 'var(--rwl-spacing-lg)' }}
                    onClick={onShowMoreClicked}
                >
                    <If condition={data?.count > MAX_MATCHING_JOBS}>
                        <Then>More like this</Then>
                        <Else>See these on the map</Else>
                    </If>
                </GhostButtonNeutral>
            </When>
        </div>
    );
};
